export const menuItems = [
  {
    name: "projects",
    label: "projects",
    isMega: true,
    items: [
      {
        name: "web",
        label: "web",
        items: [
          { name: "erus", label: "erus" },
          { name: "kite", label: "kite" },
          { name: "erus-certificaciones", label: "erus certificaciones" },
          { name: "wingman", label: "wingman" },
          { name: "alumni", label: "alumni" },
          { name: "eventos-cov", label: "eventos cov" },
          { name: "caffenio", label: "caffenio" },
          { name: "novutek-ui", label: "novutek ui" },
        ],
      },
      {
        name: "mobile",
        label: "mobile",
        items: [
          { name: "teper", label: "teper conductores" },
        ],
      },
      {
        name: "vr",
        label: "virtual reality",
        items: [
          { name: "nasa-spaceapps", label: "nasa spaceapps" },
        ],
      },
    ],
  },
];
